export default __webpack_public_path__ + "static/media/ISPA.479e636a.png";